import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-button-ver-mas',
  templateUrl: './button-ver-mas.component.html',
  styleUrls: ['./button-ver-mas.component.sass'],
})
export class ButtonVerMasComponent {
  @Output() click: EventEmitter<any> = new EventEmitter();

  constructor() {}
}
